import React from 'react'
import { useParams } from 'react-router-dom'
import AdminEmploymeUserSection from '../components/AdminEmploymeUserSection'

const AdminJobSeekerDetails = () => {
  const { userId } = useParams()

  return (
    <section className="mx-auto max-w-4xl">
      <AdminEmploymeUserSection
        userId={userId}
        expectedRole="JOB_SEEKER"
        backPath="/admin/app/employme/job-seekers"
        backLabel="Back to Job Seekers"
        roleLabel="Job seeker"
      />
    </section>
  )
}

export default AdminJobSeekerDetails
